<template>
  <div>
    <div class="home-module content">
      <div
        class="goods-item"
        v-for="(item, key) in data"
        :key="key"
        @click="gotoPage(item)"
      >
        <div class="img">
          <img
            :src="item.thumbnail"
            :atl="item.name"
          />
        </div>
        <div
          class="item-content-footer"
          :style="{background: isShowBg ? '#f8ebe4' : ''}"
        >
          <div class="tit">{{ item.name }}</div>
          <div class="pri">
            <span class="pri-1">￥{{ item.mktprice }}</span><span class="pri-2">会员价</span><span class="pri-3">￥{{ item.price }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="hasMore"
      @click="moreHandler"
      style="text-align: center;margin-top: 20px;color: #858585;font-size: 18px;cursor: pointer;"
    >
      <span> 加载更多>></span>
    </div>
  </div>

</template>

<script>
import { typeHome } from "api/home.js";

export default {
  props: ["type", "num", "isShowBg"],
  data() {
    return {
      data: [],
      pageNo: 1,
      loading: false,
      hasMore: false,
    };
  },
  watch: {
    type: {
      deep: true, // 深度监听
      handler(newVal, oldVal) {
        this.data = [];
        this.pageNo = 1;
        this.hasMore = false;
        this.fetchPerferenceType("249");
      },
    },
  },
  mounted() {
    this.fetchPerferenceType(this.num, this.pageNo);
  },
  methods: {
    moreHandler() {
      this.pageNo = this.pageNo + 1;
      this.fetchPerferenceType(this.num, this.pageNo);
    },
    fetchPerferenceType(pageSize, pageNum) {
      if (this.loading) return;
      this.loading = true;
      pageNum = pageNum || this.pageNo;
      typeHome(this.type, pageNum, pageSize).then((res) => {
        this.loading = false;
        if (res.resCode === 1) {
          const {
            list = [],
            pageNo,
            hasNext,
            pageSize,
            pages,
            total,
          } = res.data;
          this.hasMore = hasNext;
          let temp = this.data;
          this.data = temp.concat(list);
        }
      });
    },
    gotoPage(item) {
      let text = this.$router.resolve({
        path: `/goods?goods_id=${item.goodsId}`,
      });
      window.open(text.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.home-module {
  display: flex;
  flex-wrap: wrap;
  .goods-item {
    width: 298px;
    border-radius: 28px;
    background: #fff;
    display: flex;
    flex-direction: column;
    margin-right: 6px;
    margin-bottom: 20px;
    border: 1px solid #F3F3F3;
    cursor: pointer;
    &:hover {
      border: 1px solid #EC671A
    }
    &:last-child {
      margin-right: 0;
    }
    .img {
      display: table-cell;
      text-align: center;
      vertical-align: middle;
      width: 300px;
      height: 300px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 28px 28px 0 0;
      }
    }
    .item-content-footer {
      height: 112px;
      text-align: center;
      display: flex;
      justify-content: end;
      flex-direction: column;
      border-radius: 0 0 28px 28px;
      // background: rgb(248, 235, 228);
      .tit {
        display: inline-block;
        font-size: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 12px;
      }
      .pri {
        font-size: 24px;
        .pri-1 {
          color: #393939;
        }
        .pri-2 {
          color: #fb4758;
          font-size: 16px;
          margin: 0 8px;
        }
        .pri-3 {
          color: #949494;
          font-size: 20px;
        }
      }
    }
  }
}

// .content {
//   margin: 10px 0;
// }
</style>



// WEBPACK FOOTER //
// list.vue?07397166